var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show === "true" || _vm.show === true
    ? _c(
        "div",
        {
          staticClass: "box",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.close.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "dataModification" }, [
            _c("div", { staticClass: "headline" }, [
              _c("span", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.definiteModification.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("确定修改")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dataInput" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                ref: "integralFocusing",
                attrs: {
                  type: "text",
                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                },
                domProps: { value: _vm.value },
                on: {
                  focus: function($event) {
                    return _vm.$emit("noDisplay")
                  },
                  blur: function($event) {
                    return _vm.$emit("permittedDisplay")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.value = $event.target.value
                  }
                }
              })
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d373644", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d373644","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/paperless/components/dataModificationElement/index.vue
// module id = null
// module chunks = 